import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "./Navbar";

const Best3DWork = () => {
  const images = [
    "/construsct.webp",
    "/3d.jpg",
    "/desginservice.jpg",
    "/civil.jpg",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageToggle = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <Container className="my-5">
      <Row className="align-items-center">
        {/* Image Section (Left Side) */}
        {/* <Col md={6} className="text-center">
          <img
            src={images[currentImageIndex]}
            alt="3D Design"
            className="img-fluid rounded shadow-lg"
            style={{ transition: "opacity 0.5s ease-in-out", cursor: "pointer" }}
            onClick={handleImageToggle}
            onMouseEnter={handleImageToggle}
          />
        </Col> */}

        {/* Text Section (Right Side) */}
        {/* <Col md={6}>
          <h3 className="text-primary text-uppercase fw-bold">Our Work</h3>
          <h1 className="fw-bold text-dark">Best 3D Work for Your Business</h1>
          <p className="text-muted mt-3">
          We believe that our client’s growth is our growth, hence we empower businesses with help of automation and digitalization.
          </p>

          
          <Row className="mt-4">
            {[
              {  text: "Delivery of projects on time" },
              {  text: "Professional Staff" },
              {  text: "High quality services" },
              {  text: "24/7 support" },
            ].map((item, index) => (
              <Col sm={6} key={index} className="d-flex align-items-center gap-2">
                <span className="fs-4">{item.icon}</span>
                <p className="mb-0">{item.text}</p>
              </Col>
            ))}
          </Row>

          
          <Link to="/gallery" className="mt-4 d-inline-block text-primary fw-bold">
            Explore Gallery →
          </Link>
        </Col> */}
      </Row>
    </Container>
  );
};

const Home = () => {
  return (
    <div>
      <CustomNavbar />
      <Best3DWork />
    </div>
  );
};

export default Home;
